module.exports = __webpack_public_path__ + "static/img/bnr_MSA.7873952.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/domain3/bnr_MSA.png
// module id = Apei
// module chunks = 0